//hooks
import { useState } from 'react';
import { UserConsumer } from '../../hooks/context/UserContext';
import { useApi } from '../../hooks/useApi';

//translate
import { useTranslation } from 'react-i18next';
import i18n from '../../translate/i18n';

//css file
import styles from "./CarDetails.module.css"

//component
import TimeAndHourBooking from '../../component/TimeAndHourBooking';
import AddImges from '../../component/addAndDeleteImages/AddImges';
import AddClaims from '../../component/cliams/AddClaims';

//mui
import Dialog, { DialogProps } from '@mui/material/Dialog';
import { CardMedia } from '@mui/material';
import CardActionArea from '@mui/material/CardActionArea';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';


//mui icon
import CloseIcon from '@mui/icons-material/Close';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import EmojiFlagsIcon from '@mui/icons-material/EmojiFlags';
import KeyboardTabIcon from '@mui/icons-material/KeyboardTab';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import PersonIcon from '@mui/icons-material/Person';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';

//swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

//type
import { carBookingType } from '../../api/Cars/type/CarsType';
import { AddReviwesRequestType } from '../../api/booking/type/BookingType';



//utilis
import { formatDateTimeUTC } from '../../utils/formatDateTime';

//api
import { PostCancelBookingApi } from '../../api/booking/PostCancelBookingApi';
import { PostConfirmBookingApi } from '../../api/booking/PostConfirmBookingApi';
import { PostPrepareCheckinApi } from '../../api/booking/PostPrepareCheckinApi';
import { PostCheckOutApi } from '../../api/booking/PostCheckOutApi';
import { PostCheckinApi } from '../../api/booking/PostCheckinApi';
import { PostAddReviwesApi } from '../../api/booking/PostAddReviwesApi';
import { PostAddClaimApi } from '../../api/Host/PostAddClaimApi';



//rating
import { Rating } from "@smastrom/react-rating";
import "@smastrom/react-rating/style.css";

//formik and yap
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

const storageURL = process.env.REACT_APP_STORAGE_BASE_URL;


interface bestCarDetailsProps {
    selectedCar: carBookingType,
    setSelectedCar: (selectedCar: carBookingType | null) => void
    openCarDetailsBooking: {open:boolean,scrollType: DialogProps['scroll'];},
    setOpenCarDetailsBooking: (value: {open:boolean,scrollType: DialogProps['scroll']}) => void
    timeFilter: string
    status: string
    setPage: (page: number) => void
    setBookingCarsData: (bookingCarsData: carBookingType[]) => void
    fetchBookings: (currentTimeFilter?: string, currentStatus?: string) => Promise<void>
}

const CarDetailsBooking = ({selectedCar, setSelectedCar, openCarDetailsBooking, setOpenCarDetailsBooking, timeFilter, status, setPage, setBookingCarsData, fetchBookings}:bestCarDetailsProps) => {
    const {t} = useTranslation()
    const {theme} = UserConsumer();
    const [showReadyForDeliveryAndCheckOut, setShowReadyForDeliveryAndCheckOut] = useState<boolean>(false);
    const [showAddReviews, setShowAddReviews] = useState<boolean>(false);
    const [showAddClaims, setShowAddClaims] = useState<boolean>(false);
    const {
    loading: cancelLoading,
    error: cancelError,
    HandlerApi: postCancelBooking
    } = useApi(PostCancelBookingApi, "Post");
    const {
    loading: confirmLoading,
    error: confirmError,
    HandlerApi: postConfirmBooking
    } = useApi(PostConfirmBookingApi, "Post");
    const {
    loading: prepareCheckinLoading,
    error: prepareCheckinError,
    HandlerApi: postPrepareCheckin
    } = useApi(PostPrepareCheckinApi, "Post");
    const {
    loading: checkinLoading,
    error: checkinError,
    HandlerApi: postCheckin
    } = useApi(PostCheckinApi, "Post");
    const {
    loading: checkOutLoading,
    error: checkOutError,
    HandlerApi: postCheckOut
    } = useApi(PostCheckOutApi, "Post");
    const {
    loading: addReviwesLoading,
    error: addReviwesError,
    HandlerApi: postAddReviwes
    } = useApi(PostAddReviwesApi, "Post");
    const {
    loading: addClaimsLoading,
    error: addClaimsError,
    HandlerApi: postAddClaims
    } = useApi(PostAddClaimApi, "Post");

    const AddReviwesSchema = Yup.object().shape({
        rating: Yup.number()
            .min(1, t("please_select_at_least_1_star")) // أقل قيمة مسموحة
            .required(t("rating_is_required")),
        
        comment: Yup.string()
            .trim()
            .min(5, t("comment_must_be_at_least_5_characters"))
            .required(t("comment_is_required")),
    });

    const handleCancelBooking = async (id: number) =>{
        let result = await postCancelBooking(id);
        if(result.data) {
            setOpenCarDetailsBooking({open:false, scrollType: "paper"});
            setSelectedCar(null);
            setPage(1)
            setBookingCarsData([]);
            await fetchBookings(timeFilter, status);
        }
    }
    const handleConfirmBooking = async (id: number) =>{
        let result = await postConfirmBooking(id);
        if(result.data) {
            setOpenCarDetailsBooking({open:false, scrollType: "paper"});
            setSelectedCar(null);
            setPage(1)
            setBookingCarsData([]);
            await fetchBookings(timeFilter, status);
        }
    }
    const handleCheckinBooking = async (id: number) =>{
        let result = await postCheckin(id);
        if(result.data) {
            setOpenCarDetailsBooking({open:false, scrollType: "paper"});
            setSelectedCar(null);
            setPage(1)
            setBookingCarsData([]);
            await fetchBookings(timeFilter, status);
        }
    }

    const handleAddReviews = async (values: AddReviwesRequestType)=>{
        if(values.driver_id === null) {
            delete values.driver_id
        }
        let result = await postAddReviwes(values);
        if(result.code === 200) {
            handleCloseBookingDialog();
        }
    }
    const handleCloseBookingDialog = ()=>{
        setOpenCarDetailsBooking({open:false, scrollType: "paper"}) 
        setSelectedCar(null)
        setShowReadyForDeliveryAndCheckOut(false);
        setShowAddReviews(false)
        setShowAddClaims(false);
    }
    return (
        <Dialog
        open={openCarDetailsBooking.open}
        onClose={handleCloseBookingDialog}
        scroll={openCarDetailsBooking.scrollType}
        maxWidth="sm"
        fullWidth
        >
            <DialogContent className="!overflow-x-hidden !h-[700px] !p-0 !pb-3" dividers={openCarDetailsBooking.scrollType === 'paper'}>
                {showReadyForDeliveryAndCheckOut === false && showAddReviews === false && showAddClaims === false
                ?
                <div>
                    <div className='relative overflow-hidden'>
                        <div className={`flex justify-end absolute px-3 top-3 z-10`}>
                            <IconButton
                            className={`${selectedCar?.car.fuel_type === "electric" ? "!bg-electricColor" : theme === "client" ? "!bg-customerColor" : "!bg-paretnerColor"} !rounded-md max-sm:!w-[30px] max-sm:!h-[30px]`}
                            onClick={handleCloseBookingDialog}
                            size="large"
                            >
                                <CloseIcon className='!text-white'/>
                            </IconButton>
                        </div>
                        <span className={`absolute sm:top-64 top-40 px-3 py-1 z-10 ${i18n.language === "en" ? "right-3" : "left-3"} rounded-lg text-white text-sm font-semibold 
                        ${
                            selectedCar?.current_status === 'pending' ? 'bg-yellow-500' :
                            selectedCar?.current_status === 'confirmed' ? 'bg-green-500' :
                            selectedCar?.current_status === 'ready_for_check_in' ? 'bg-blue-500' :
                            selectedCar?.current_status === 'checked_in' ? 'bg-indigo-500' :
                            selectedCar?.current_status === 'checked_out' ? 'bg-purple-500' :
                            selectedCar?.current_status === 'completed' ? 'bg-teal-500' :
                            selectedCar?.current_status === 'cancelled' ? 'bg-red-500' :
                            selectedCar?.current_status === 'disputed' ? 'bg-orange-600' :
                            'bg-gray-400' 
                        }`}>
                            {t(`${selectedCar?.current_status}`)}
                        </span>
                        <div>
                            <div>
                                <CardActionArea className={` ${i18n.language === "en" ? `ltrSwiper ${styles.ltrSwiper}` : `rtlSwiper ${styles.rtlSwiper}`}`}>
                                    <Swiper
                                    key={i18n.language}
                                    dir={i18n.language === "ar" ? "rtl" : "ltr"}
                                    loop={true}
                                    spaceBetween={30}
                                    navigation
                                    pagination={{ clickable: true }}
                                    modules={[Navigation, Pagination]}
                                    className={`carCardDetailsSwiper ${styles.carCardDetailsSwiper} ${selectedCar?.car.fuel_type === "electric" ? `electricSwiper ${styles.electricSwiper}` : theme=== "client" ? `clientSwiper ${styles.clientSwiper}`: `paretnerSwiper ${styles.paretnerSwiper}`}`}
                                >
                                    {selectedCar?.car?.primary_images.map((img, index) => (
                                    <SwiperSlide
                                    className="
                                    !flex 
                                    justify-center 
                                    items-center 
                                    sm:!h-[300px] max-sm:!h-[200px]
                                    "
                                    key={index}
                                    >
                                        <CardMedia
                                        component="img"
                                        src={`${storageURL}/${img.url}`}
                                        className='!h-full'
                                        alt="no_photo"
                                        />
                                    </SwiperSlide>
                                    ))}
                                    </Swiper>
                                </CardActionArea>
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-center items-center gap-10 mt-3">
                        <div className='flex items-center'>
                            <LocationOnOutlinedIcon className={selectedCar?.car.fuel_type === "electric" ? "!text-electricColor" : theme === "client" ? "!text-customerColor" : "!text-paretnerColor"}/>
                            <span className="ml-1">{selectedCar?.location_in}</span>
                        </div>
                        <div>
                            {i18n.language === "en" ? <KeyboardTabIcon/> : <KeyboardTabIcon className='rotate-180'/>}
                        </div>
                        <div className='flex items-center'>
                            <EmojiFlagsIcon className='!text-red-500'/>
                            <span className="ml-1">{selectedCar?.location_out}</span>
                        </div>
                    </div>
                    <div className='px-3 mt-7'>
                        <div>
                            <p className='text-darkColor font-[800] sm:text-xl max-sm:text-sm mb-3'>{t("reservations_schedule")}</p> 
                            <div className='flex flex-wrap justify-between gap-3 rounded-2xl border p-3 border-gray-300 overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300'>
                                <div className='flex flex-col gap-3'>
                                    <TimeAndHourBooking
                                    title={t("checkin_date")}
                                    value={`${formatDateTimeUTC(selectedCar?.check_in_at || "").date}`}
                                    icon={<CalendarTodayIcon/>}
                                    type = {selectedCar?.car.fuel_type}
                                    />  
                                    <TimeAndHourBooking
                                    title={t("checkout_date")}
                                    value={`${formatDateTimeUTC(selectedCar?.check_out_at || "").date}`}
                                    icon={<CalendarMonthIcon/>}
                                    type = {selectedCar?.car.fuel_type}
                                    />  
                                </div>
                                <div className='flex flex-col gap-3'>
                                    <TimeAndHourBooking
                                    title={t("checkin_time")}
                                    value={`${formatDateTimeUTC(selectedCar?.check_in_at || "").time}`}
                                    icon={<QueryBuilderIcon/>}
                                    type = {selectedCar?.car.fuel_type}
                                    />  
                                    <TimeAndHourBooking
                                    title={t("checkout_time")}
                                    value={`${formatDateTimeUTC(selectedCar?.check_out_at || "").time}`}
                                    icon={<WatchLaterIcon/>}
                                    type = {selectedCar?.car.fuel_type}
                                    />  
                                </div>
                            </div>
                        </div>
                        <div className='mt-3'>
                            <p className='text-darkColor font-[800] sm:text-xl max-sm:text-sm mb-3'>{t("car_info")}</p> 
                            <div className='flex justify-between gap-3 rounded-2xl border p-3 border-gray-300 overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300'>
                                <TimeAndHourBooking
                                title={t("color")}
                                value={selectedCar?.car.color || ""}
                                icon={<ColorLensIcon/>}
                                type = {selectedCar?.car.fuel_type}
                                />  
                                <TimeAndHourBooking
                                title={t("is_confirmed")}
                                value={selectedCar?.is_confirmed === 1 ? t("yes") : t("no")}
                                icon={<ConfirmationNumberIcon/>}
                                type = {selectedCar?.car.fuel_type}
                                />
                            </div>
                        </div>
                        {selectedCar?.host
                        ?                    
                        <div className='mt-3'>
                            <p className='text-darkColor font-[800] sm:text-xl max-sm:text-sm mb-3'>{t("car_owner_info")}</p> 
                            <div className='flex justify-between gap-3 rounded-2xl border p-3 border-gray-300 overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300'>
                                <TimeAndHourBooking
                                title={t("full_name")}
                                value={selectedCar?.host.user?.full_name || ""}
                                icon={<PersonIcon/>}
                                type = {selectedCar?.car.fuel_type}
                                />  
                            </div>
                        </div>
                        :
                        <></>
                        }
                        {selectedCar?.driver
                        ?
                        <div className='mt-3'>
                            <p className='text-darkColor font-[800] sm:text-xl max-sm:text-sm mb-3'>{t("car_driver_info")}</p> 
                            <div className='flex justify-between gap-3 rounded-2xl border p-3 border-gray-300 overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300'>
                                <TimeAndHourBooking
                                title={t("full_name")}
                                value={selectedCar?.driver.user?.full_name || ""}
                                icon={<PersonIcon/>}
                                />  
                            </div>
                        </div>
                        :<></>
                        }
                        {
                            theme === "host"
                            ?   selectedCar?.current_status === "pending"
                                ?
                                    <div className='flex justify-center mt-5'>
                                        <Button
                                            onClick={()=> {handleConfirmBooking(selectedCar?.id) }} 
                                            className={`${selectedCar.car.fuel_type === "electric" ? "!bg-electricColor": "!bg-paretnerColor"} !w-[390px] sm:!h-[62px] max-sm:!h-[40px] !rounded-[62px] !text-white !capitalize`}>
                                            {
                                                confirmLoading
                                                ? <CircularProgress/>
                                                : t("confirm_booking")
                                            }
                                        </Button>
                                    </div>
                                :   selectedCar?.current_status === "confirmed"
                                    ?
                                        <div className='flex justify-center mt-5'>
                                            <Button
                                            onClick={()=> {setShowReadyForDeliveryAndCheckOut(true) }}
                                            className={`!bg-paretnerColor !w-[390px] sm:!h-[62px] max-sm:!h-[40px] !rounded-[62px] !text-white !capitalize`}>
                                                {
                                                    cancelLoading 
                                                    ? <CircularProgress/>
                                                    : t("ready_for_delivery")
                                                }
                                            </Button>
                                        </div>
                                    :selectedCar?.current_status === "completed"
                                        ?
                                            <div className='flex justify-center mt-5'>
                                                <Button
                                                onClick={()=> {setShowAddClaims(true) }}
                                                className={`${selectedCar.car.fuel_type === "electric" ? "!bg-electricColor": "!bg-paretnerColor"} !w-[390px] sm:!h-[62px] max-sm:!h-[40px] !rounded-[62px] !text-white !capitalize`}>
                                                    {
                                                        cancelLoading 
                                                        ? <CircularProgress/>
                                                        : t("add_claim")
                                                    }
                                                </Button>
                                            </div>
                                        :<></>
                                                
                            :<></>
                        }
                        {
                            theme === "client" 
                            ? selectedCar?.current_status === 'pending'
                                ? 
                                    <div className='flex justify-center mt-5'>
                                        <Button onClick={()=> {handleCancelBooking(selectedCar?.id) }} 
                                            className={`${selectedCar.car.fuel_type === "electric" ? "!bg-electricColor": "!bg-customerColor"} !w-[390px] sm:!h-[62px] max-sm:!h-[40px] !rounded-[62px] !text-white !capitalize`}>
                                            {
                                                cancelLoading
                                                ? <CircularProgress/>
                                                : t("cancel_booking")
                                            }
                                        </Button>
                                    </div>
                                : selectedCar?.current_status === 'completed'
                                    ?
                                        <div className='flex justify-center mt-5'>
                                            <Button 
                                                onClick={()=> {setShowAddReviews(true)}}
                                                className={`${selectedCar.car.fuel_type === "electric" ? "!bg-electricColor": "!bg-customerColor"} !w-[390px] sm:!h-[62px] max-sm:!h-[40px] !rounded-[62px] !text-white !capitalize`}>
                                                {
                                                    cancelLoading
                                                    ? <CircularProgress/>
                                                    : t("add_reviews")
                                                }
                                            </Button>
                                        </div>
                                    :<></>
                            :<></>
                        }
                        {
                            theme !== "host"
                            ? selectedCar?.current_status === "ready_for_check_in"
                                ?
                                selectedCar.driver !== null
                                    ? theme === "driver"
                                        ?
                                        <div className='flex justify-center mt-5'>
                                            <Button 
                                            onClick={()=> {handleCheckinBooking(selectedCar?.id)}} 
                                            className={`${selectedCar.car.fuel_type === "electric" ? "!bg-electricColor":"!bg-paretnerColor"} !w-[390px] sm:!h-[62px] max-sm:!h-[40px] !rounded-[62px] !text-white !capitalize`}>
                                                {
                                                    checkinLoading 
                                                    ? <CircularProgress/>
                                                    : t("checked_in")
                                                }
                                            </Button> 
                                        </div>
                                        :<></>
                                    :
                                    <div className='flex justify-center mt-5'>
                                        <Button 
                                        onClick={()=> {handleCheckinBooking(selectedCar?.id) }} 
                                        className={`${selectedCar.car.fuel_type === "electric" ? "!bg-electricColor":"!bg-customerColor"} !w-[390px] sm:!h-[62px] max-sm:!h-[40px] !rounded-[62px] !text-white !capitalize`}>
                                            {
                                                checkinLoading 
                                                ? <CircularProgress/>
                                                : t("checked_in")
                                            }
                                        </Button>
                                    </div>
                                :
                                selectedCar?.current_status === "checked_in"
                                    ?
                                    selectedCar.driver !== null
                                        ? theme === "driver"
                                            ?
                                            <div className='flex justify-center mt-5'>
                                                <Button 
                                                onClick={()=> {setShowReadyForDeliveryAndCheckOut(true) }}
                                                className={`${selectedCar.car.fuel_type === "electric" ? "!bg-electricColor": "!bg-paretnerColor"} !w-[390px] sm:!h-[62px] max-sm:!h-[40px] !rounded-[62px] !text-white !capitalize`}>
                                                    {
                                                        checkOutLoading 
                                                        ? <CircularProgress/>
                                                        : t("checked_out")
                                                    }
                                                </Button> 
                                            </div>
                                            :<></>
                                        :
                                        <div className='flex justify-center mt-5'>
                                            <Button 
                                            onClick={()=> {setShowReadyForDeliveryAndCheckOut(true) }}
                                            className={`${selectedCar.car.fuel_type === "electric" ? "!bg-electricColor": "!bg-customerColor"} !w-[390px] sm:!h-[62px] max-sm:!h-[40px] !rounded-[62px] !text-white !capitalize`}>
                                                {
                                                    checkOutLoading 
                                                    ? <CircularProgress/>
                                                    : t("checked_out")
                                                }
                                            </Button> 
                                        </div>
                                    :<></>
                            :<></>
                        }
                    </div>
                </div>
                : showAddReviews 
                    ? 
                    <div className='p-5'>
                        <div className="flex items-center gap-2 mb-3 cursor-pointer" onClick={() => {setShowAddReviews(false)}}>
                            <p>{i18n.language === "en" ? <ArrowBackOutlinedIcon /> : <ArrowForwardIcon />}</p>
                            <p className='text-sm'>{t("back")}</p>
                        </div>
                        <div>
                            <Formik
                            initialValues={{
                                booking_id: selectedCar?.id, 
                                driver_id: selectedCar?.driver !== null ? selectedCar?.driver?.id : null,
                                rating: 0,
                                comment: ""
                            }}
                            validationSchema={AddReviwesSchema}
                            onSubmit={(values)=>handleAddReviews(values)}
                            >
                        {({ values,touched, errors,setFieldValue, setFieldTouched}) => (
                            <Form>
                                <div className='mt-2'>
                                    <div className='flex flex-col gap-10'>
                                        <div>
                                            <Rating
                                            value={values.rating}
                                            onChange={(value: number) => {setFieldValue("rating", value)}}
                                            items={5}
                                            style={{ maxWidth: 250 }}
                                            className='!m-auto'
                                            />
                                            {touched.rating && errors.rating && (
                                                <div className="text-red-500 text-sm">{errors.rating}</div>
                                            )}
                                        </div>
                                        <Field
                                        as={TextField}
                                        name="comment"
                                        label={t("comment")}
                                        className="w-full"
                                        helperText={touched.comment && errors.comment ? errors.comment : ""}
                                        error={touched.comment && Boolean(errors.comment)}
                                        />
                                    </div>
                                </div>
                                <div className='mt-5 flex justify-center'>
                                    <Button 
                                    className={`h-[45px] ${selectedCar?.car?.fuel_type === "electric" ? "!bg-electricColor" : "!bg-customerColor"} !text-white !rounded-full`} type="submit">
                                        {addReviwesLoading 
                                        ? <CircularProgress className='w-1 h-1'/>
                                        :t("confirm")
                                        }
                                    </Button>
                                </div>
                            </Form>
                        )}
                            </Formik>
                        </div>
                    </div>
                    : showAddClaims
                        ?
                        <div className='p-5'>
                            <div className="flex items-center gap-2 mb-3 cursor-pointer" onClick={() => {setShowAddClaims(false)}}>
                                <p>{i18n.language === "en" ? <ArrowBackOutlinedIcon /> : <ArrowForwardIcon />}</p>
                                <p className='text-sm'>{t("back")}</p>
                            </div>
                            <AddClaims 
                            callFunction={postAddClaims}
                            loading={addClaimsLoading}
                            setCloseDialog={setOpenCarDetailsBooking}
                            reCallfetchApi={fetchBookings}
                            setData={setBookingCarsData}

                            selectedCar={selectedCar}
                            setSelectedCar={setSelectedCar}
                            id={selectedCar?.id}
                            timeFilter={timeFilter}
                            status={status}
                            setPage={setPage}
                            />
                        </div>
                        :
                        <div className='p-5'>
                            <div className="flex items-center gap-2 mb-3 cursor-pointer" onClick={() => {setShowReadyForDeliveryAndCheckOut(false)}}>
                                <p>{i18n.language === "en" ? <ArrowBackOutlinedIcon /> : <ArrowForwardIcon />}</p>
                                <p className='text-sm'>{t("back")}</p>
                            </div>
                            <div>
                                <AddImges
                                selectedCar={selectedCar} 
                                setSelectedCar={setSelectedCar}
                                setCloseDialog={setOpenCarDetailsBooking}
                                callFunction={theme === "host" ? postPrepareCheckin: postCheckOut} 
                                loading={theme === "host" ? prepareCheckinLoading : checkOutLoading}
                                timeFilter={timeFilter}
                                status={status}
                                setPage={setPage}
                                setBookingCarsData={setBookingCarsData}
                                fetchBookings={fetchBookings}
                                typeForAddimages={theme === "host" ? "prepareCheckin" : "checkOut"}
                                />
                            </div>
                        </div>
                }
            </DialogContent>
        </Dialog>
    )
}

export default CarDetailsBooking